import axios from 'axios'
import url from '@/URL.js'
import router from '@/router/index'

function verifyToken(err) {
    if(err.response.status === 401) {
        localStorage.removeItem('editorToken')
        router.push('/editor/login')
    }
}
export const state = {
    token : localStorage.getItem('editorToken'),
    loading:false,
    error:'',
    success:'',
    agreements:[],
    categories:[]
}

export const mutations = {
 LOADING(state, request) {
     state.loading = request
 },
 ERROR(state, request) {
     state.error = request
     setTimeout(function( ){
        state.error = null
     },2000)
 },
 SUCCESS(state,request) {
     state.success = request;
     setTimeout(function( ){
        state.success = null
     },2000)
 },
 CLEAR(state){
    state.success = ''
 },
 
 DELETE_CATEGORY(state, {id,key}){
     
     state.categories.splice(key,1)
    
 },
 ADD_AGREEMENT(state,agreement) {
    state.agreements = agreement
 },
 APPROVE_AGREEMENT(state,{id,key}) {
   for(let i = 0; i <= state.agreements.length; i++) {
        state.agreements[key].approve = true
    } 
    return state.agreements;
    
 }, 
 DELETE_AGREEMENT(state,{id,key}) {
    state.categories.splice(key,1)
 },
 ADD_CATEGORY(state, category) {
     state.categories.push(category)
 },
 ADD_CATEGORIES(state, categories) {
    state.categories = categories
}
}

export const actions = {
   async addCategory({commit}, payload) {
        commit('LOADING', true)
        commit('CLEAR')
      
        try {
          const {data, status} = await axios.post(`${url()}/api/actioncommons/category/create`,
          {
              "name":payload
          }
          , 
          {
               headers: {
                   Authorization : `${localStorage.getItem('editorToken')}`
               }
           })
           
          if(status === 200) {
              commit('LOADING',false)
              commit('SUCCESS','Your category have been created successfully')
              commit('ADD_CATEGORY', data.category)
          }
                
        } catch( err ) {
            console.log(err)
            verifyToken(err)
        }

    },
    async getCategories({commit}){
          try {
              const {data, status} = await axios.get(`${url()}/api/actioncommons/categories`)
              if(status === 200) {
                  commit('ADD_CATEGORIES', data)
              }
    
          } catch( err) {
              if(err.response.status === 400){
                  commit('ERROR','An Error Occured Try Again!')
              }
          }
          
      },
    // remove category
   async deleteCategory({commit}, {id,key}) {
        commit('CLEAR')
        commit('LOADING', false)
            try {
                const {data, status} = await axios.delete(`${url()}/api/actioncommons/category/${id}`,
            {
                headers: {
                    Authorization: `${localStorage.getItem('editorToken')}`
                }
            })
                    
            if(status === 200) {
                commit('LOADING', false)
                commit('SUCCESS', "Your category have been deleted successfully.")
                commit('DELETE_CATEGORY',{id,key})
            }
            }catch( err ){
                console.log(err)
                verifyToken(err)
            }
    
    },

    //fetch all agreements
    async getAgreements({commit}, id) {
        commit('LOADING',true)

            try {
                const {data, status} = await axios.get(`${url()}/api/actioncommons/agreements/${id}/editor`, {
                    headers: {
                        Authorization: `${localStorage.getItem('editorToken')}`
                    }
                })
                //console.log('response', data)
                if(status === 200) {
                    commit('LOADING', false)
                    commit('ADD_AGREEMENT',data.agreements)
                }
            }catch( err ) {
                console.log(err)
                verifyToken(err)
            }
        
    },
    // approve agreement

   async approveAgreement({commit}, {id, key}){
        commit('LOADING', true)
         /* try {
                axios.defaults.headers.common['Authorization'] = `${localStorage.getItem('editorToken')}`;
                const {data, status} = await axios.patch(`${url()}/api/actioncommons/agreements/${id}/approve`)
                console.log('response', data)
                    if(status === 200) {
                        commit('LOADING', false)
                        commit('SUCCESS', 'Agreement Approved successfully')
                        commit('APPROVE_AGREEMENT', {id, key})
                    }
            } catch( err ) {
                console.log(err.response)
                verifyToken(err)
            }
            */
            commit('APPROVE_AGREEMENT', {id, key})
    },
    //Delete Agreement

    async deleteAgreement({commit}, {id,key}){
        commit('LOADING', true) 
         try {
            const response = await axios.delete(`${url()}/api/actioncommons/agreement/${id}/editor-delete`, {
                headers: {
                    Authorization: `${localStorage.getItem('editorToken')}`
                }
            })
             if(response.status === 200) {
                commit("LOADING", false)
                commit('SUCCESS', 'Agreement deleted successfully')
                commit('DELETE_AGREEMENT',{id, key})
            }
        }catch( err ) {
            //console.log(err)
            verifyToken(err)
        } 
        
    },
     
}

export const getters = {

}